import {LevelName, LevelNameValues, Level, TileNameValues, TileName} from './level';
import { Level1 } from './Level1';
import { Level2 } from './Level2';
import { Level3 } from './Level3';
import { Level4 } from './Level4';
import { Level5 } from './Level5';
import { Level6 } from './Level6';
import { Level7 } from './Level7';
import { Level8 } from './Level8';
import { Level9 } from './Level9';
import { Level10 } from './Level10';
import { Level11 } from './Level11';
import { Level12 } from './Level12';
import { Level13 } from './Level13';
import { Level14 } from './Level14';
import { Level15 } from './Level15';
import { Level16 } from './Level16';
import Tile, {TileType, TileTypeValues} from "../Tile";
import Taz from "../../prefabs/tiles/Taz";
import Bumper from "../../prefabs/tiles/Bumper";
import Powerup, {PowerupName, PowerupNameValues} from "../../game/powerups/Powerup";
import BugsBunnyPowerup from "../../prefabs/powerups/BugsBunnyPowerup";
import PorkyPigPowerup from "../../prefabs/powerups/PorkyPigPowerup";
import MarvinMartianPowerup from "../../prefabs/powerups/MarvinMartianPowerup";
import RoadRunnerPowerup from "../../prefabs/powerups/RoadRunnerPowerup";
import TweetyBirdPowerup from "../../prefabs/powerups/TweetyBirdPowerup";
import YosemiteSamPowerup from "../../prefabs/powerups/YosemiteSamPowerup";
import {LevelManager} from "~/js/game/LevelManager";
import Critter from "../../prefabs/tiles/Critter";

// import { level5 } from './level5';

export class LevelUtil {
  protected static levelNameToLevelLookup: Record<LevelNameValues, Level> = {
    [LevelName.Level1]: Level1,
    [LevelName.Level2]: Level2,
    [LevelName.Level3]: Level3,
    [LevelName.Level4]: Level4,
    [LevelName.Level5]: Level5,
    [LevelName.Level6]: Level6,
    [LevelName.Level7]: Level7,
    [LevelName.Level8]: Level8,
    [LevelName.Level9]: Level9,
    [LevelName.Level10]: Level10,
    [LevelName.Level11]: Level11,
    [LevelName.Level12]: Level12,
    [LevelName.Level13]: Level13,
    [LevelName.Level14]: Level14,
    [LevelName.Level15]: Level15,
    [LevelName.Level16]: Level16
  };

  protected static nextLevelLookup: Record<LevelNameValues, LevelNameValues | undefined> = {
    [LevelName.Level1]: LevelName.Level2,
    [LevelName.Level2]: LevelName.Level3,
    [LevelName.Level3]: LevelName.Level4,
    [LevelName.Level4]: undefined,
    [LevelName.Level5]: LevelName.Level6,
    [LevelName.Level6]: LevelName.Level7,
    [LevelName.Level7]: LevelName.Level8,
    [LevelName.Level8]: undefined,
    [LevelName.Level9]: LevelName.Level10,
    [LevelName.Level10]: LevelName.Level11,
    [LevelName.Level11]: LevelName.Level12,
    [LevelName.Level12]: undefined,
    [LevelName.Level13]: LevelName.Level14,
    [LevelName.Level14]: LevelName.Level15,
    [LevelName.Level15]: LevelName.Level16,
    [LevelName.Level16]: undefined
  };

  protected static nextLevelToUnlockLookup: Record<LevelNameValues, LevelNameValues | undefined> = {
    [LevelName.Level1]: LevelName.Level2,
    [LevelName.Level2]: LevelName.Level3,
    [LevelName.Level3]: LevelName.Level4,
    [LevelName.Level4]: LevelName.Level5,
    [LevelName.Level5]: LevelName.Level6,
    [LevelName.Level6]: LevelName.Level7,
    [LevelName.Level7]: LevelName.Level8,
    [LevelName.Level8]: LevelName.Level9,
    [LevelName.Level9]: LevelName.Level10,
    [LevelName.Level10]: LevelName.Level11,
    [LevelName.Level11]: LevelName.Level12,
    [LevelName.Level12]: LevelName.Level13,
    [LevelName.Level13]: LevelName.Level14,
    [LevelName.Level14]: LevelName.Level15,
    [LevelName.Level15]: LevelName.Level16,
    [LevelName.Level16]: undefined
  };

  public static isLastLevel(levelName:LevelNameValues) : boolean
  {
    return levelName == LevelName.Level16;
  }

  public static getLevelFromName(levelName: LevelNameValues) {
    return this.levelNameToLevelLookup[levelName];
  }

  public static getNextLevel(previousLevel: LevelNameValues): LevelNameValues | undefined {
    let nextLevel = LevelUtil.nextLevelLookup[previousLevel];
    return nextLevel;
  }

  public static getNextLevelToUnlock(previousLevel: LevelNameValues): LevelNameValues | undefined {
    let nextLevel = LevelUtil.nextLevelToUnlockLookup[previousLevel];
    return nextLevel;
  }

  public static calculateStarRating(level: Level, blocksBroken: number, totalTiles:number): number {
    let stars:integer = 0;
    
    for(let i = 0; i < 3; ++i)
    {
      let target = Math.floor(level.smashLevels.smashLevels[i]*(totalTiles/100));
      if(blocksBroken >= target)
      {
        stars = (i+1);
      }
    }
    return stars;
  }

  public static getTile(tileName:TileTypeValues, scene:any, levelManager:LevelManager, x:number,y:number,properties:any[],tilemap:string,id:number):Tile | undefined
  {
    switch (tileName){
      case TileType.Critter:
        return new Critter(scene,levelManager,x,y,properties,tilemap,id);
      case TileType.Bumper:
        return new Bumper(scene,levelManager,x,y,properties);
    }

    return new Tile(scene,levelManager,x,y,properties,tilemap,id);
  }

  public static getPowerup(selectedTeamMate:string, scene:any,x:number,y:number):Powerup|undefined
  {
    switch (selectedTeamMate)
    {
      case PowerupName.BugsBunny:
        return new BugsBunnyPowerup(scene,x,y);
      case PowerupName.PorkyPig:
        return new PorkyPigPowerup(scene,x,y);
      case PowerupName.MarvinMartian:
        return new MarvinMartianPowerup(scene,x,y);
      case PowerupName.RoadRunner:
        return new RoadRunnerPowerup(scene,x,y);
      case PowerupName.TweetyBird:
        return new TweetyBirdPowerup(scene,x,y);
      case PowerupName.YosemiteSam:
        return new YosemiteSamPowerup(scene,x,y);
    }

    return undefined;
  }


}
